import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "title"
}

import { reactive, onMounted, computed } from "vue";
import type { PropType } from "vue";
import { useStore } from "vuex";
import type { Application, Applicant } from "@/models/application";
import Tile from "@/components/shared/Tile.vue";
import ApplicationChecklistItem from "@/components/ApplicationChecklistItem.vue";
import useChecklistHelpers from "@/use/checklistHelpers";
import Income from "@/components/checklist/Income.vue";
import ChecklistItemWrapper from "@/components/checklist/ChecklistItemWrapper.vue";
import { ProductIds } from "@/config/constants";
import { SortedCheckListItem } from "@/models/checklist";


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationChecklist',
  props: {
  applicant: Object as PropType<Applicant>,
  application: Object as PropType<Application>,
},
  emits: ["hydrateStore"],
  setup(__props, { emit: __emit }) {

const { updateStipulationStatus, replaceObjectWithId } = useChecklistHelpers();

const props = __props;

const emit = __emit;
const store = useStore();

const showCompletedItems = computed<boolean>(
  () => sortedItemsState.value?.filter((item: any) => item.complete === true)?.length > 0,
);
const applicationId = computed<number>(() => store.state.appData.application.id);
const productTypeId = computed<number>(() => store.state.appData.application.productTypeId);
const sortedItemsState = computed<SortedCheckListItem[]>(() => store.state.checklistModule.sortedItems);

const incomeStips = computed(() => {
  if (sortedItemsState?.value && sortedItemsState?.value?.length > 0) {
    let stips = sortedItemsState?.value?.find((s: any) => s.title === "Income Verification")?.items;
    return stips && stips?.length > 0;
  } else {
    return undefined;
  }
});

const showDefaultIncomeSourceSelector = computed(
  () => incomeStips.value === undefined || incomeStips.value === false,
);
const showIncomeVerificationTile = computed(
  () => store.state.checklistModule?.showIncomeVerification === true,
);

const incomeVerificationChecklistItems = computed<SortedCheckListItem[]>(() => {
  return sortedItemsState.value.filter(
    (item: SortedCheckListItem) =>
      item.complete !== true && item.formattedTitle === "Income Verification",
  );
});

const nonIncomeVerificationChecklistItems = computed<SortedCheckListItem[]>(() => {
  return sortedItemsState.value.filter(
    (item: SortedCheckListItem) =>
      item.complete !== true && item.formattedTitle !== "Income Verification",
  );
});

let sortedItems = reactive([] as any[]);

async function getApplicationStips() {
  await store.dispatch("checklistModule/getSortedChecklistItems");
}

async function handleUploadSuccess(event: any) {
  const status =
    store.state.lookupsModule?.lookups?.stipStatuses?.length > 0
      ? store.state.lookupsModule?.lookups?.stipStatuses.find(
          (s: any) => s.name?.trim() === "Pending",
        )
      : false;
  if (applicationId.value) {
    const response = await updateStipulationStatus(applicationId.value, status, event);
    replaceObjectWithId(sortedItems, response.id, response);
  }

  // update the item status
  store.dispatch("checklistModule/getSortedCheklistItemStatuses");
}

function updateChecklistItem(event: any) {
  replaceObjectWithId(sortedItems, event.id, event);
  // update the item status
  store.dispatch("checklistModule/getSortedCheklistItemStatuses");
}

onMounted(async () => {
  await getApplicationStips();
  sortedItems = store.getters["checklistModule/sortedItems"];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tile, null, {
    default: _withCtx(() => [
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "title" }, "To-Do List", -1)),
      (productTypeId.value === _unref(ProductIds).LOC || productTypeId.value === _unref(ProductIds).PEL)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (showDefaultIncomeSourceSelector.value && showIncomeVerificationTile.value)
              ? (_openBlock(), _createBlock(ChecklistItemWrapper, {
                  key: 0,
                  title: 'Income Verification',
                  complete: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(Income, {
                      applicant: __props.applicant,
                      application: __props.application,
                      onIncomeSourcesUpdated: getApplicationStips
                    }, null, 8, ["applicant", "application"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (sortedItemsState.value.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (productTypeId.value === _unref(ProductIds).LOC || productTypeId.value === _unref(ProductIds).PEL)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(incomeVerificationChecklistItems.value, (item, index) => {
                  return (_openBlock(), _createBlock(ApplicationChecklistItem, {
                    key: index,
                    item: item,
                    onHandleUploadSuccess: _cache[0] || (_cache[0] = ($event: any) => (handleUploadSuccess($event))),
                    onIncomeSourcesUpdated: getApplicationStips
                  }, null, 8, ["item"]))
                }), 128))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nonIncomeVerificationChecklistItems.value, (item, index) => {
              return (_openBlock(), _createBlock(ApplicationChecklistItem, {
                key: index,
                item: item,
                onHandleUploadSuccess: _cache[1] || (_cache[1] = ($event: any) => (handleUploadSuccess($event))),
                onIncomeSourcesUpdated: getApplicationStips,
                onAddressMismatchStipUpdated: _cache[2] || (_cache[2] = ($event: any) => (updateChecklistItem($event)))
              }, null, 8, ["item"]))
            }), 128)),
            (showCompletedItems.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Completed Items"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedItemsState.value.filter((item) => item.complete === true), (item, index) => {
              return (_openBlock(), _createBlock(ApplicationChecklistItem, {
                key: index,
                item: item
              }, null, 8, ["item"]))
            }), 128))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})